import { applicationSettings } from '../../settings/application';

function FakeStorage() {
  this.length = 0;
}

FakeStorage.prototype = {
  setItem: function (key, val) {
    this[key] = val;
    this.length = Object.keys(this).length - 1;
  },
  getItem: function (key) {
    return this[key] || null;
  },
  removeItem: function (key) {
    delete this[key];
    this.length = Object.keys(this).length - 1;
  },
  clear: function () {
    Object.keys(this).forEach(function (key) {
      if (this.hasOwnProperty(key)) {
        delete this[key];
      }
    }, this);
    this.length = Object.keys(this).length - 1;
  },
  key: function (index) {
    return Object.keys(this)[index + 1] || null; // + 1 since this.length
  },
};

const uid = Date();
const hasTag = new RegExp(applicationSettings.applicationName + '$');

function decideStorage(type) {
  let storage;
  let variant;
  try {
    storage = localStorage;
    variant = 'localStorage';
    storage.setItem(uid, uid);
    if (storage.getItem(uid) !== uid || type === 'session') {
      throw new Error("localStorage doesn't work");
    }
    storage.removeItem(uid);
  } catch (error) {
    try {
      storage = sessionStorage;
      variant = 'sessionStorage';
      storage.setItem(uid, uid);
      if (storage.getItem(uid) !== uid) {
        throw new Error('sessionStorage doesnt work');
      }
      storage.removeItem(uid);
    } catch (error) {
      variant = 'appStorage';
      storage = new FakeStorage();
    }
  }
  return {
    storage: storage,
    variant: variant,
  };
}

function tag(key) {
  return key + '-' + applicationSettings.applicationName;
}

function wrapStorage(storageStuff) {
  const storage = storageStuff.storage;
  const variant = storageStuff.variant;
  return {
    /*
        need to know what type of storage we're using.
        keep this in wrapper so we dont pollute the real storage
        */
    variant: variant,
    setItem: function (key, val) {
      return storage.setItem(tag(key), val);
    },
    getItem: function (key) {
      return storage.getItem(tag(key));
    },
    length: storage.length,
    removeItem: function (key) {
      return storage.removeItem(tag(key));
    },
    clear: function () {
      for (const key in storage) {
        if (hasTag.test(key) && storage.hasOwnProperty(key)) {
          storage.removeItem(key);
        }
      }
    },
    key: function (key) {
      return storage.key(tag(key));
    },
  };
}

function getLocalStorage() {
  return wrapStorage(decideStorage('local'));
}

function getSessionStorage() {
  return wrapStorage(decideStorage('session'));
}

const api = {
  session: getSessionStorage(),
  local: getLocalStorage(),
};

export default api;
